import store from 'utils/configureStore';
import messages_en from "translations/en.json";
import messages_de from "translations/de.json";
import messages_fr from "translations/fr.json";
import messages_ar from "translations/ar.json";
import messages_zh from "translations/zh.json";
import messages_ko from "translations/ko.json";
import { createIntl, createIntlCache } from 'react-intl';

export const getLocale = localeCode => {
  let locale = locales.find(l => l.code === localeCode);
  if (!locale) {
    locale = locales[0];
  }
  return locale;
};

export const locales = [{
  code: 'en',
  flagCode: 'CA',
  name: "English",
  dir: 'ltr' as const,
  messages: messages_en,
},{
  code: 'de',
  flagCode: 'DE',
  name: "Deutsch",
  dir: 'ltr' as const,
  messages: messages_de,
},{
  code: 'fr',
  flagCode: 'FR',
  name: "Français",
  dir: 'ltr' as const,
  messages: messages_fr,
},
{
  code: 'ar',
  flagCode: 'SA',
  name: "العربية",
  dir: 'rtl' as const,
  messages: messages_ar,
},
{
  code: 'zh',
  flagCode: 'CN',
  name: "中文",
  dir: 'ltr' as const,
  messages: messages_zh,
},{
  code: 'ko',
  flagCode: 'KR',
  name: "한국어",
  dir: 'ltr' as const,
  messages: messages_ko,
}];

export const getIntlObject = () => {
  const state = store.getState();
  const locale = getLocale(state.app.user.localeCode);
  return createIntl({ locale: locale.code, messages: locale.messages }, createIntlCache());
};